import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCommentAltRedo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M10.3 10.75A1 1 0 1 0 9 9.25 3 3 0 1 1 7 4a3 3 0 0 1 2.23 1H8a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0 5 5 0 1 0 .3 7.75M19 6h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H9a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73A1 1 0 0 0 21 22a1.1 1.1 0 0 0 .4-.08A1 1 0 0 0 22 21V9a3 3 0 0 0-3-3" />
  </svg>
);
export default SvgCommentAltRedo;
